import React from "react";

const Resultado = ({ exibirCodigo, linha, leadCod, sucesso, mensagem }) => {
  return (
    <tr key={linha}>
      <td>{linha}</td>
      {exibirCodigo ? <td>{leadCod}</td> : null}
      <td>
        <span
          className={sucesso ? "badge badge-success" : "badge badge-danger"}
        >
          {sucesso ? "Sucesso" : "Erro"}
        </span>
      </td>
      <td>{mensagem}</td>
    </tr>
  );
};

export default Resultado;
